module.exports = __webpack_public_path__ + "img/cloae.6a9f27a4.svg";